/* istanbul ignore file */
import { useEmployeeAssignmentUrl } from 'domain/people/employee/assignments/assignmentRouting';
import { useFieldHelper } from 'framework/ui/field';
import { useAuthorization } from 'framework/authorization';
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';
import { CREATE_ASSIGNMENT } from 'domain/shared/assignment';

const CopyEmployeeAssignmentButton = (props: Omit<LinkButtonProps, 'url'>) => {
  const { getCopyEntityUrl } = useEmployeeAssignmentUrl();
  const { getValue: getId } = useFieldHelper(props);
  const id = getId();
  const { isGranted } = useAuthorization();

  return isGranted(CREATE_ASSIGNMENT) ? (
    <LinkButton permissionToCheck={CREATE_ASSIGNMENT} variant="outlined" {...props} url={getCopyEntityUrl(String(id))}>
      Copy
    </LinkButton>
  ) : null;
};

export default CopyEmployeeAssignmentButton;
